import { Plus } from "@phosphor-icons/react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

export default function AddPaymentMethodButton({
  onClick,
}: {
  onClick: () => void;
}) {
  const { role } = useSelectedWorkspaceContext();

  const canUpdatePaymentMethod = role === "owner";

  const button = (
    <button
      type="button"
      className="group flex items-center justify-start gap-2 rounded-2xl text-sm-bold disabled:bg-black-200 disabled:text-black-400 border border-dashed border-black-200 bg-white px-2 py-1.5 transition-colors duration-300 ease-in-out hover:bg-black-100 disabled:cursor-not-allowed"
      disabled={!canUpdatePaymentMethod}
      onClick={onClick}
    >
      <div className="flex size-8 items-center justify-center rounded-full bg-black-950 group-disabled:bg-black-400">
        <Plus className="size-4 text-white" />
      </div>
      Add payment method
    </button>
  );

  return canUpdatePaymentMethod ? (
    button
  ) : (
    <Tooltip>
      <TooltipTrigger asChild>{button}</TooltipTrigger>
      <TooltipContent>
        Only the Owner can add a new payment method
      </TooltipContent>
    </Tooltip>
  );
}
